
import request from '@/common/js/request'

/**
 * 大屏数据
 */
 export const getTypeData = (params) => {
    return request('/screenApi/statistics',{
        params: params,
        method: 'get'
    })
}
